import React from 'react';

import image from '../../assets/img_candidate_profile.png';

import styles from './WhyItWorks.scss';

const WhyItWorks = () => {
  return (
    <div id="Why-join" className={styles.WhyItWorks}>
      <div className={styles.Container}>
        <div className={styles.Wrapper}>
          <div className={styles.Column1}>
            <h3 className={styles.SecondaryTitle}>Why It Works</h3>
            <div className={styles.Description}>
              <ul>
                <li>Fewer interviews. Stronger outcomes.</li>
                <li>Faster hires that actually ramp.</li>
                <li>Confidence you&apos;re choosing from the top of the market.</li>
                <li>Three flexible ways to hire.</li>
              </ul>
            </div>
          </div>
          <div className={styles.Column2}>
            <img src={image} alt="Top sales talent" className={styles.Image} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyItWorks;
